<template>
  <div class="HierarchyHeader grid gap-2">
    <div
      class="rounded-md font-semibold shadow-md border border-gray-300 overflow-hidden"
    >
      <div class="bg-info text-white px-4 py-2">
        Csak 2 perc. Töltsd ki a gyors ajánlatkérés mezőt, vagy görgess le és
        válassz egy szakit.
      </div>
      <div class="text-info text-3xl font-bold px-4 !py-5">
        Ingyenes árajánlat értékelt szakiktól
      </div>
      <div class="bg-info text-white px-4 py-2">
        <div class="text-xl font-bold">{{ profession.name }}</div>
        <div class="text-xl font-bold">{{ city.name }}</div>
        <div class="text-sm">Csak 2 perc. Ingyenes</div>
      </div>
    </div>
    <QuickOffer
      :hide-steps="true"
      @requestTender="$emit('requestTender', $event)"
    />
  </div>
</template>

<script>
import QuickOffer from "../app/boxes/QuickOffer.vue";

export default {
  components: { QuickOffer },
  props: {
    profession: {
      type: Object,
      required: true,
    },
    city: {
      type: Object,
      required: true,
    },
  },
};
</script>
